import React, { Component } from 'react';

import reduce from 'lodash/reduce';
import get from 'lodash/get';

import { Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import http from '../../../shared/http';

import SettingField from './field';

import './main.less';

const initialSettings = {
	'settings-hints': true,
	'languages': true,
	'offers-full-info-button': true,
	'offers-lang-column': true,
	'offer-past-manual': true,
	'offer-attributes': true,
	'offer-targeting-max-aff-payout': true,
	'conversions-approve-all-offers': true
};

class Settings extends Component {
	componentDidMount() {
		const id = this.props.router.location.hash.slice(1);

		const element = document.getElementById(id);

		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });

			element.style.backgroundColor = 'var(--main-color-90)';

			setTimeout(() => {
				element.style.backgroundColor = 'transparent';
			}, 2000);
		}
	}

	render() {
		const { handleSubmit, onSubmit } = this.props;

		return (
			<Form
				className='ui-form create-admin admin-setting-form'
				onSubmit={handleSubmit((data) => onSubmit(data))}
			>
				<div>Settings:</div>

				<SettingField
					id='settings-hints'
					title='Settings hints (*)'
				/>
				<SettingField
					id='languages'
					title='Additional languages in switcher'
				/>

				<div className='group'>
					<div>Offer list:</div>
					<SettingField
						id='offers-full-info-button'
						title='Button: Full info'
					/>
					<SettingField
						id='offers-lang-column'
						title='Column: LANG'
					/>
				</div>

				<div className='group'>
					<div>Offer:</div>
					<SettingField
						id='offer-past-manual'
						title='Minimum leads per day for past manual approve (field)'
					/>
					<SettingField
						id='offer-attributes'
						title='Attributes of the offer (right column)'
					/>
					<SettingField
						id='offer-targeting-max-aff-payout'
						title='Targeting (columns: "% comp" and "Max aff payout")'
					/>
				</div>

				<div className='group'>
					<div>Conversions approve:</div>
					<SettingField
						id='conversions-approve-all-offers'
						title='Use all offers in filter'
					/>
				</div>

				<div className="ui-form__element buttons">
					<button
						className="ui-btn ui-btn-primary"
					>
						Save settings
					</button>
					<button
						className="ui-btn ui-btn-cancel"
						type="button"
						onClick={() => history.back()}
					>
						Back
					</button>
				</div>
			</Form>
		);
	}
}

const SettingsForm = reduxForm({ form: 'adminSettings' })(withRouter(Settings));

export default connect(
	(state) => {
		const settings = get(state, 'form.adminsForm.values.settings.hidden_items');
		const adminId = get(state, 'form.adminsForm.values.id');

		return {
			initialValues: {
				settings: reduce(settings, (result, value) => ({ ...result, [value]: false }), initialSettings),
				adminId
			}
		};
	},
	(dispatch) => ({
		onSubmit: async (data) => {
			const request = http({
				url: `/v2/admins/${data.adminId}/settings`,
				method: 'put',
				data: {
					hidden_items: Object.entries(data.settings).filter(([_, value]) => !value).map(([key]) => key)
				},
				actions: ['']
			});

			return request(dispatch).then(() => window.location.reload());
		}
	})
)(SettingsForm);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/settings/main.js